import { Provider } from "@angular/core";
import { provideMetadata } from "@tylertech/metadata-module";
import { AttachmentActionHandler, DialogActionHandler, FinanceApprovalActionHandler, IntentActionHandler, MetadataActionHandler, NoteActionHandler, PopupActionHandler, ShareActionHandler, UrlActionHandler } from "./actionHandlers";
import { ActionHandlerType, AGGREGATE_ACTION_HANDLERS } from "./interfaces";
import { AggregateActionHandlerRepository, AggregateActionService, AggregateHelperService, AggregateManagerService, AggregateService } from "./services";


export function provideAggregates(...handlers: ReadonlyArray<ActionHandlerType>): Array<Provider>
{
    const standardAggregateActionHandlers: ReadonlyArray<ActionHandlerType> = [
        DialogActionHandler,
        IntentActionHandler,
        PopupActionHandler,
        ShareActionHandler,
        UrlActionHandler,
        MetadataActionHandler,
        FinanceApprovalActionHandler,
        NoteActionHandler,
        AttachmentActionHandler,
    ];

    return [
        provideMetadata(),
        {
            provide: AGGREGATE_ACTION_HANDLERS,
            multi: true,
            useValue: standardAggregateActionHandlers,
        },
        ...standardAggregateActionHandlers,
        {
            provide: AGGREGATE_ACTION_HANDLERS,
            multi: true,
            useValue: handlers ?? [],
        },
        AggregateActionHandlerRepository,
        AggregateActionService,
        AggregateHelperService,
        AggregateManagerService,
        AggregateService,
    ];
}
